export const selectListGenerator = (
  list: string[],
  labelMapping?: { [key: string]: string }
) => {
  return list.map(v => {
    const label = labelMapping ? labelMapping[v] : v;
    return {
      value: v,
      label: label
    };
  });
};
